<button
  type="button"
  class="w-30px h-30px rounded-full bg-secondary"
  [matMenuTriggerFor]="menu"
>
  <span class="text-white">U</span>
</button>
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="logout()">Logout</button>
  <div class="text-txt text-8px text-right pr-8px">
    Version - {{ appVersion }}
  </div>
</mat-menu>
